import { GenericCardWrapper } from 'pages/Franchisee/OpenClaim/sharedStyles';
import styled from 'styled-components';

export const CardUploadWrapper = styled(GenericCardWrapper)`
  width: 212px;
  padding: 18px 14px 27px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 570px) {
    max-width: 100%;
  }
`;

export const CardUploadTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0em;
  text-align: left;
  padding: 0 10px;
  color: ${({ theme }) => theme.colors.text};
  height: auto;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  span {
    color: ${({ theme }) => theme.colors.error};
  }
  @media (max-width: 570px) {
    height: auto;
    margin-bottom: 15px;
  }
`;
